import axios from 'axios';

const API_URL = '/api/super-admin';

export const createBusinessAccount = async (businessId, payload) => {
  const { data } = await axios.post(`${API_URL}/businesses/${businessId}/accounts`, payload);
  return data;
};

export const resendAccountInvite = async (businessId, accountId) => {
  const { data } = await axios.post(
    `${API_URL}/businesses/${businessId}/accounts/${accountId}/resend-invite`,
  );
  return data;
};

export const resetAccountPassword = async (accountId) => {
  const { data } = await axios.post(`${API_URL}/accounts/${accountId}/reset-password`);
  return data;
};
